import { DateTime } from 'luxon';

export const firstCollectedDateAlignsWithStartDate = (firstCollectedDate: Date, startDate: Date): boolean => {
  const firstCollected = DateTime.fromJSDate(firstCollectedDate);
  const start = DateTime.fromJSDate(startDate);
  const firstCollectedDaysInMonth = firstCollected.daysInMonth ?? 31;

  const sameDayOfMonth = firstCollected.day === Math.min(start.day, firstCollectedDaysInMonth);
  const bothEndOfMonth = firstCollected.day === firstCollectedDaysInMonth && start.day === (start.daysInMonth ?? 31);

  return sameDayOfMonth || bothEndOfMonth;
};
